export default __webpack_public_path__ + "static/media/title-en.b56bfc80.webp";